import { IxFileUploader } from './IxFileUploader.js';

customElements.define('ix-file-uploader', IxFileUploader);
